<script>

export let color;
export let hover = color;
</script>

<div style="background-color: {color};" onMouseOut="this.style.backgroundColor='{color}'" onMouseOver="this.style.backgroundColor='{hover}'">
    <slot/>
</div>

<style>
    div {
        overflow: hidden;
        width: 100%;
        height: 100%;
    }
</style>